/**
 * User invitation entity — mirrors `leviathan_master.user_invitations`.
 *
 * Issued by an owner/super_admin, consumed via `POST /users/accept-invite`.
 */
import { z } from 'zod';
import { Email, ISO8601Date, InvitationId, TenantId, UserId, } from '../primitives/index.js';
import { InvitationStatus, InviteableRole } from '../enums/index.js';
export const InvitationSchema = z.object({
    id: InvitationId,
    tenantId: TenantId,
    email: Email,
    name: z.string().min(1).max(100).nullable(),
    role: InviteableRole,
    /** Opaque invitation token included in the invite URL. */
    token: z.string().min(32).max(64),
    invitedBy: UserId,
    status: InvitationStatus,
    expiresAt: ISO8601Date,
    acceptedAt: ISO8601Date.nullable(),
    createdAt: ISO8601Date,
});
/** Safe to return in list views — omits the opaque token. */
export const InvitationPublicSchema = InvitationSchema.omit({ token: true });
export const InvitationCreateSchema = z.object({
    email: Email,
    name: z.string().min(1).max(100).optional(),
    role: InviteableRole,
});
/** Payload used by the public `accept-invite` endpoint. */
export const InvitationAcceptSchema = z.object({
    token: z.string().min(32).max(64),
    password: z.string().min(8).max(128),
    name: z.string().min(1).max(100).optional(),
});
//# sourceMappingURL=invitation.js.map